import { lazy } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { Route } from './types';

const PageNotFound = lazy(() => import('@/pages/PageNotFound/index'));
const ClaimRole = lazy(() => import('@/pages/ClaimRole/index'));
const MyProfile = lazy(() => import('@/pages/MyProfile/index'));
const Home = lazy(() => import('@/pages/Home/index'));
const Users = lazy(() => import('@/pages/Users/index'));
const WorkCenters = lazy(() => import('@/pages/WorkCenters/index'));
const Workers = lazy(() => import('@/pages/Workers/index'));
const Vehicles = lazy(() => import('@/pages/Vehicles/index'));
const AccreditationProcessDetails = lazy(() => import('@/pages/AccreditationProcessDetails/index'));
const AssignedAccreditationProcessesV2 = lazy(
  () => import('@/pages/AssignedAccreditationProcessesV2/index')
);

const RedirectAssignedAccreditationProcessesV2 = () => {
  const { search } = useLocation();

  return <Navigate replace to={`/assigned-accreditation-processes${search}`} />;
};

export const privateRoutes: Route = {
  accreditationProcessDetails: {
    Component: AccreditationProcessDetails,
    path: '/accreditation-process-details',
  },
  assignedAccreditationProcesses: {
    Component: AssignedAccreditationProcessesV2,
    path: '/assigned-accreditation-processes',
  },
  assignedAccreditationProcessesV2: {
    Component: RedirectAssignedAccreditationProcessesV2,
    path: '/assigned-accreditation-processes-v2',
  },
  claimRole: {
    Component: ClaimRole,
    path: '/claim-role',
  },
  home: {
    Component: Home,
    path: '/home',
  },
  myProfile: {
    Component: MyProfile,
    path: '/my-profile',
  },
  pageNotFound: {
    Component: PageNotFound,
    path: '*',
  },
  root: {
    Component: () => <Navigate replace to="/home" />,
    path: '/',
  },
  users: {
    Component: Users,
    path: '/users',
  },
  vehicles: {
    Component: Vehicles,
    path: '/vehicles',
  },
  workCenters: {
    Component: WorkCenters,
    path: '/work-centers',
  },
  workers: {
    Component: Workers,
    path: '/workers',
  },
};
